import * as React from 'react';
import { cn } from '@/lib/utils';
import { Field, FieldLabel, FieldDescription } from '@/components/ui/field';
import { ComboboxSingle } from '@/components/ui/combobox-single';
import { ComboboxMultiple } from '@/components/ui/combobox-multiple';
import { FormFieldErrorText } from './form-field';

export const FormCombobox = React.forwardRef(
  (
    {
      id,
      className,

      // data
      options = [],
      value,
      onValueChange,

      // UI
      label,
      placeholder = 'Selecione...',
      description,
      emptyMessage = 'Nenhum resultado encontrado.',
      loading = false,
      disabled = false,
      multiple = false,

      // error handling
      hasError = false,
      errorText = 'Campo inválido',

      ...props
    },
    ref
  ) => {
    const generatedId = React.useId();
    const fieldId = id || generatedId;

    const ComboboxComponent = multiple ? ComboboxMultiple : ComboboxSingle;

    return (
      <Field
        ref={ref}
        className={cn('c-form-combobox', disabled && '[&>label]:cursor-not-allowed [&>label]:opacity-50', className)}
      >
        {label && <FieldLabel htmlFor={fieldId}>{label}</FieldLabel>}

        <ComboboxComponent
          id={fieldId}
          options={options}
          value={value}
          onValueChange={onValueChange}
          placeholder={loading ? 'Carregando...' : placeholder}
          emptyMessage={loading ? 'Carregando opções...' : emptyMessage}
          disabled={disabled}
          aria-invalid={hasError}
          className={cn(hasError && 'border-danger focus-visible:ring-danger')}
          {...props}
        />

        {description && <FieldDescription>{description}</FieldDescription>}

        {hasError && <FormFieldErrorText>{errorText}</FormFieldErrorText>}
      </Field>
    );
  }
);

FormCombobox.displayName = 'FormCombobox';
